import { Injectable } from "@angular/core";
import { BehaviorSubject, catchError, throwError } from "rxjs";
import FileSaver from "file-saver";
import { ApiServiceService } from "../../../../services/api-service.service";
import { environment } from "../../../../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class CompanyOffersService {

    refreshList = new BehaviorSubject<boolean>(false);
    constructor(private service: ApiServiceService) { }

    getAllOffers(filterModel: any): any {
        return this.service.get(`${environment.apiUrl}/offers`, filterModel)
            .pipe(catchError(this.handleError));
    }

    offersWithVendors(filterModel: any): any {
        return this.service.get(`${environment.apiUrl}/offers-with-vendors`, filterModel)
            .pipe(catchError(this.handleError));
    }

    getAllRequestedOffers(filterModel: any): any {
        return this.service.get(`${environment.apiUrl}/offers/requests`, filterModel)
            .pipe(catchError(this.handleError));
    }

    getOfferTypes(): any {
        return this.service.get(`${environment.apiUrl}/offers/types`)
            .pipe(catchError(this.handleError));
    }

    // vendors-list-with-search
    getVendorListWithSearch(filterModel: any): any {
        return this.service.get(`${environment.apiUrl}/vendors-list-with-search`, filterModel)
            .pipe(catchError(this.handleError));
    }

    getBranchesOfVendor(vendorId: any): any {
        return this.service.get(`${environment.apiUrl}/vendors/${vendorId}/branches`)
            .pipe(catchError(this.handleError));
    }


    ExportOffers(model: any) {
        return this.service.getDownload(`${environment.apiUrl}/offers/export/excel`, model)
            .pipe(catchError(this.handleError));
    }

    PrintPDF_Offers(model: any) {
        return this.service.getDownload(`${environment.apiUrl}/offers/export/pdf`, model)
            .pipe(catchError(this.handleError));
    }


    ExportOfferRequests(model: any) {
        return this.service.getDownload(`${environment.apiUrl}/offers/requests/export/excel`, model)
            .pipe(catchError(this.handleError));
    }

    PrintPDF_OfferRequests(model: any) {
        return this.service.getDownload(`${environment.apiUrl}/offers/requests/export/pdf`, model)
            .pipe(catchError(this.handleError));
    }

    saveAsExcelFile(buffer: any, fileName: string): void {
        const data: Blob = new Blob([buffer]);
        FileSaver.saveAs(data, fileName);
    }


    // Offer Profile [Start]

    getOfferDetails(offerId: any): any {
        return this.service.get(`${environment.apiUrl}/offers/details?offer_id=${offerId}`)
            .pipe(catchError(this.handleError));
    }

    getOfferUsersRedeemed(model: any): any {
        return this.service.get(`${environment.apiUrl}/offers/offer-not-applied-users`, model)
            .pipe(catchError(this.handleError));
    }

    getOfferUsersClaimed(model: any): any {
        return this.service.get(`${environment.apiUrl}/offers/offer-applied-users`, model)
            .pipe(catchError(this.handleError));
    }
    getOfferBranches(model: any): any {
        return this.service.get(`${environment.apiUrl}/offers/offer-branches`, model)
            .pipe(catchError(this.handleError));
    }

    getOfferCompanies(model: any): any {
        return this.service.get(`${environment.apiUrl}/offers/offer-companies`, model)
            .pipe(catchError(this.handleError));
    }

    getOfferDepartments(offerId: any, model: any): any {
        return this.service.get(`${environment.apiUrl}/offers/${offerId}/departments`, model)
            .pipe(catchError(this.handleError));
    }


    // Offer Profile [End]




    // Offer Request Profile [Start]

    getOfferRequestDetails(offerId: any): any {
        return this.service.get(`${environment.apiUrl}/offers/requests/${offerId}`)
            .pipe(catchError(this.handleError));
    }

    getOfferRequestBranches(id: string): any {
        return this.service.get(`${environment.apiUrl}/offers/requests/${id}/branches`)
            .pipe(catchError(this.handleError));
    }

    getOfferRequestDepartement(model: any, id: string): any {
        return this.service.get(`${environment.apiUrl}/offers/requests/${id}/departments`, model)
            .pipe(catchError(this.handleError));
    }


    // Offer Request Profile [End]



    getDepartments(filterModel: any): any {
        return this.service.get(`${environment.apiUrl}/company-profile/departments`, filterModel)
            .pipe(catchError(this.handleError));
    }



    handleError(error: any) {
        return throwError(error);
    }
}
